import styled from 'styled-components';

export const MenuItem = styled.div`
	width: 330px;
	display: grid;
	grid-template-columns: 1fr;
	padding: 7px 14px;
	height: 60px;
`;
